import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { DepartureVM } from '../../../../../../models/ArrivalDepartureModel';

@Component({
  selector: 'app-back-office24-ordershuttlebus-departure',
  templateUrl: './back-office24-ordershuttlebus-departure.component.html',
  styleUrl: './back-office24-ordershuttlebus-departure.component.css',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})

export class BackOffice24OrderShuttlebusDepartureComponent implements OnInit {
  @Input() departureVM: DepartureVM;

  constructor() { }

  ngOnInit(): void {
  }

}
